import { renderBlocks } from '@/components/blocks';
import { Layout } from '@/components/layout/Layout';
import { useDynamicYield } from '@/lib/useDynamicYield';

import type {
  SanityPageType,
  SanityProgrammeType,
  SanitySEOType,
} from '@/types/sanity';
import type { GlobalNextPageProps } from '@/types/shared';

interface ProgrammesProps extends GlobalNextPageProps {
  programmes: SanityProgrammeType[];
  programmesPage: {
    SEO: SanitySEOType;
    blocks: SanityPageType['blocks'];
  };
}

const SharedProgrammeCatalogueLayout = ({
  programmes,
  programmesPage,
  siteSettings,
  locale,
  draftMode,
  navigation,
}: ProgrammesProps) => {
  const { recommendationContext } = useDynamicYield(locale, 'PRODUCT', [
    'PROGRAMMES',
  ]);

  return (
    <Layout
      SEO={programmesPage?.SEO}
      siteSettings={siteSettings}
      localeTranslations={true}
      preview={draftMode}
      navigation={navigation}
      recommendationContext={recommendationContext}
    >
      {renderBlocks(programmesPage?.blocks, {
        programmesCatalogue: programmes,
      })}
    </Layout>
  );
};

export { SharedProgrammeCatalogueLayout };
